import { clearAnswers } from '@/src/storage/healthQuestionnaireStorage';
import { removeAuthCookies } from '@utils/cookie/index';
import { removeFirstVisit } from '@/src/storage/firstVisit';
import { removeDeepLinkAppointment } from '@/src/storage/deepLinkAppointmentStorage';
import { removeLegacyBooking } from '@/src/storage/legacyBooking';

const clearAllCookies = () => {
  removeAuthCookies();
};

export const clearAllBookingData = (clearHealthQuestionnaire = true) => {
  if (clearHealthQuestionnaire) {
    clearAnswers();
  }
};

export const clearAll = (clearHealthQuestionnaire = true) => {
  clearAllCookies();
  clearAllBookingData(clearHealthQuestionnaire);
  removeFirstVisit();
  removeDeepLinkAppointment();
  removeLegacyBooking();
  window?.analytics?.reset();
};
